import { inject } from 'vue'
import { BLOCK_CONTEXT_INJECTION_KEY } from './injection-keys'

export const useBlockContext = () => {
    return inject(BLOCK_CONTEXT_INJECTION_KEY)
}
